import React, { useEffect } from 'react';
import { useLanguageStore } from '../store/languageStore';

interface I18nProviderProps {
  children: React.ReactNode;
}

const I18nProvider: React.FC<I18nProviderProps> = ({ children }) => {
  const { language } = useLanguageStore();

  useEffect(() => {
    // Initialize language on app start
    if (language) {
      import('../i18n/config').then((i18nModule) => {
        i18nModule.default.changeLanguage(language);
      });
    }
  }, [language]);

  return <>{children}</>;
};

export default I18nProvider; 